const {
  GET_BG_ADJ_PROJECT_FETCH,
  GET_BG_ADJ_PROJECT_SUCCESS,
  GET_BG_ADJ_PROJECT_REJECTED,
  GET_BG_ADJ_BUDGET_FETCH,
  GET_BG_ADJ_BUDGET_SUCCESS,
  GET_BG_ADJ_BUDGET_REJECTED,
  GET_BG_ADJ_FETCH,
  GET_BG_ADJ_SUCCESS,
  GET_BG_ADJ_REJECTED,
  GET_BUDGET_ADJ_REMAIN_REPORT_FETCH,
  GET_BUDGET_ADJ_REMAIN_REPORT_SUCCESS,
  GET_BUDGET_ADJ_REMAIN_REPORT_REJECTED,
  GET_BUDGET_ADJ_REMAIN_REPORT_CLEAR,
} = require("src/Constants");

const initialState = {
  budgetAdjustments: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  projects: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  budgetAdjRemain: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
  budgets: {
    data: null,
    isLoading: false,
    isRejected: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BUDGET_ADJ_REMAIN_REPORT_FETCH:
      return {
        ...state,
        budgetAdjRemain: {
          isLoading: true,
          isRejected: false,
        },
      };
    case GET_BUDGET_ADJ_REMAIN_REPORT_SUCCESS:
      return {
        ...state,
        budgetAdjRemain: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_BUDGET_ADJ_REMAIN_REPORT_REJECTED:
      return {
        ...state,
        budgetAdjRemain: {
          isLoading: false,
          isRejected: true,
        },
      };
    case GET_BUDGET_ADJ_REMAIN_REPORT_CLEAR:
      return {
        ...state,
        budgetAdjRemain: {
          data: [],
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_BG_ADJ_FETCH:
      return {
        ...state,
        budgetAdjustments: { isLoading: true, isRejected: false },
      };
    case GET_BG_ADJ_SUCCESS:
      return {
        ...state,
        budgetAdjustments: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_BG_ADJ_REJECTED:
      return {
        ...state,
        budgetAdjustments: { isLoading: false, isRejected: true },
      };
    case GET_BG_ADJ_BUDGET_FETCH:
      return {
        ...state,
        budgets: { isLoading: true, isRejected: false },
      };
    case GET_BG_ADJ_BUDGET_SUCCESS:
      return {
        ...state,
        budgets: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_BG_ADJ_BUDGET_REJECTED:
      return {
        ...state,
        budgets: { isLoading: false, isRejected: true },
      };
    case GET_BG_ADJ_PROJECT_FETCH:
      return {
        ...state,
        projects: { isLoading: true, isRejected: false },
      };
    case GET_BG_ADJ_PROJECT_SUCCESS:
      return {
        ...state,
        projects: {
          data: payload,
          isLoading: false,
          isRejected: false,
        },
      };
    case GET_BG_ADJ_PROJECT_REJECTED:
      return {
        ...state,
        projects: { isLoading: false, isRejected: true },
      };
    default:
      return state;
  }
};
